import React from 'react'
import { Drawer, DrawerOverlay, DrawerBody, DrawerCloseButton, DrawerContent, Box } from "@chakra-ui/react"

export default function CustomDrawer({ isOpen, onClose, btnRef, size = "md",children }) {
    return (
        <Drawer
            isOpen={isOpen}
            placement="right"
            size={size}
            onClose={onClose}
            finalFocusRef={btnRef}
        >
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton />
                <DrawerBody>
                    <Box>
                        {children}
                    </Box>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}
